import React, { createContext, useContext, useState, useEffect } from 'react';
import { secureStorage } from '../utils/security';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true); // check token on mount

  // On app load — restore user from token if still valid
  useEffect(() => {
    const restore = async () => {
      const token = secureStorage.getToken();
      if (!token) { setLoading(false); return; }
      try {
        const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
        const res = await fetch(`${apiBase}/auth/me/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setUser(data);
        } else {
          secureStorage.clearToken();
        }
      } catch {
        secureStorage.clearToken();
      } finally {
        setLoading(false);
      }
    };
    restore();
  }, []);

  const login      = (userData) => setUser(userData);
  const updateUser = (userData) => setUser(userData);
  const logout     = ()         => { setUser(null); secureStorage.clearToken(); };

  return (
    <AuthContext.Provider value={{ user, login, updateUser, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);